/**
 * メニュー → はじめての方へ へ渡す `location.state`（PRODUCT_DEV-1191）。
 *
 * メニューから開いたときだけ、ほかのメニューの画面と同じ ← を出す。はじめて来た人に自動で出す案内
 * （手帳から送られてくる）と、ホームのカードから開いたときは渡さない。渡す側と読む側でキー名がずれると
 * ← が黙って消えるので、どちらもここを使う。
 */
export const ONBOARDING_FROM_MENU_STATE = { onboardingFrom: "menu" } as const;

export type OnboardingNavState = typeof ONBOARDING_FROM_MENU_STATE;

/** メニューから開いたか（state が無い・別の値なら false） */
export const isOnboardingFromMenu = (state: unknown): boolean =>
  (state as Partial<OnboardingNavState> | null | undefined)?.onboardingFrom === ONBOARDING_FROM_MENU_STATE.onboardingFrom;
